const MONTHS: Record<number, string> = {
  0: 'IAN',
  1: 'FEB',
  2: 'MAR',
  3: 'APR',
  4: 'MAI',
  5: 'IUN',
  6: 'IUL',
  7: 'AUG',
  8: 'SEP',
  9: 'OCT',
  10: 'NOI',
  11: 'DEC',
};

export function formatDateRange(startDate: string | null, endDate: string | null): string {
  if (!startDate || !endDate) return 'Ongoing';
  try {
    const start = new Date(startDate);
    const end = new Date(endDate);
    const startDay = start.getDate();
    const startMonth = MONTHS[start.getMonth()];
    const endDay = end.getDate();
    const endMonth = MONTHS[end.getMonth()];
    if (
      start.getDate() === end.getDate() &&
      start.getMonth() === end.getMonth() &&
      start.getFullYear() === end.getFullYear()
    ) {
      return `${startDay} ${startMonth}`;
    }
    return `${startDay} ${startMonth} - ${endDay} ${endMonth}`;
  } catch {
    return 'Ongoing';
  }
}

/** Long format for event details (e.g. "Monday, January 15, 2024" or "Jan 15 - Feb 20, 2024") */
export function formatDateRangeDetailed(startDate: string | null, endDate: string | null): string {
  if (!startDate && !endDate) return 'Date not set';
  if (startDate && endDate) {
    const start = new Date(startDate);
    const end = new Date(endDate);
    if (start.toDateString() === end.toDateString()) {
      return start.toLocaleDateString('en-US', {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      });
    }
    return `${start.toLocaleDateString('en-US', { month: 'short', day: 'numeric' })} - ${end.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}`;
  }
  const date = startDate ? new Date(startDate) : new Date(endDate!);
  return date.toLocaleDateString('en-US', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
}
